import { render } from "./PodftUploadModal.vue?vue&type=template&id=3dc80c82"
import script from "./PodftUploadModal.vue?vue&type=script&lang=js"
export * from "./PodftUploadModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__